// extracted by mini-css-extract-plugin
export default {"wrap":"referencesUserSubordination_wrap__Y-NDo"};